export const AppInfoStore = {
  version: null as string | null,
  build: null as string | null, // optional
  name: null as string | null, // optional
};
